import { version } from "../../package.json";
import Vue from "vue";
import VueI18n from "vue-i18n";
import axios from "axios";
import vuetify from "./vuetify";
import en from "@/locale/en_US";
import zh from "@/locale/zh_TW";
import store from "@/store";

import { defaultConfigs } from "@/settings";

Vue.use(VueI18n);

/**
 * Available locales
 */
export const locales = [
  {
    title: "English",
    locale: "en",
    abbr: "ENG"
  },
  {
    title: "中文",
    locale: "zh",
    abbr: "TW"
  }
];

const messages = {
  en: {
    ...en,
    $vuetify: vuetify.en
  },
  zh: {
    ...zh,
    $vuetify: vuetify.zh
  }
};

export const vuetifyI18n = new VueI18n({
  // set locale options: en_US | zh_TW
  locale: defaultConfigs.locale,
  // set locale messages
  messages
});

const getLang = ln => {
  return new Promise(resolve => {
    let langObj = {},
      lnIdx = 0;
    axios.get(`/assets/lang/${ln}.json`).then(({ data }) => {
      resolve(data);
    });
  });
};

/**
 * VueI18n instance
 */
export const i18n = new VueI18n({
  // set locale options: en_US | zh_TW
  locale: defaultConfigs.locale,
  // set locale messages
  messages: {}
});

/**
 * Set locale to new value at Vue and Vuex.
 *
 * @param {Boolean} newLocale themeDark new value
 */
export async function setLocale(locale) {
  if (i18n.locale !== locale) {
    `[Locale] Set to "${locale}"`;
    i18n.locale = locale || defaultConfigs.locale;
  }
}

const loadedLanguages = []; // our default language that is preloaded

function setI18nLanguage(lang) {
  i18n.locale = lang;
  document.querySelector("html").setAttribute("lang", lang);
  return lang;
}

export function loadLanguageAsync(language) {
  let lang = language || store.state.settings.locale || "tw";
  const ver = localStorage.getItem(`lang_${lang}_ver`);
  if (!loadedLanguages.includes(lang)) {
    if (localStorage.getItem(`lang_${lang}`) && ver && ver === version) {
      const msgs = JSON.parse(localStorage.getItem(`lang_${lang}`));
      i18n.setLocaleMessage(lang, { ...msgs });
      loadedLanguages.push(lang);
      document.title = msgs.app_name;
      return Promise.resolve(setI18nLanguage(lang));
    }
    return getLang(lang).then(msgs => {
      localStorage.setItem(`lang_${lang}`, JSON.stringify(msgs));
      localStorage.setItem(`lang_${lang}_ver`, version);
      i18n.setLocaleMessage(lang, { ...msgs });
      loadedLanguages.push(lang);
      document.title = msgs.app_name;
      return setI18nLanguage(lang);
    });
  } else {
    return Promise.resolve(setI18nLanguage(lang));
  }
}
